import React, {Component} from 'react';
import ambassadorPicture from "../Assets/optilume_ambassador_7.png";
import CardMedia from "@material-ui/core/CardMedia";
import styles from '../App.css';
import ReactPlayer from 'react-player'

colorLinks("#11ABB0");

function colorLinks(hex)
{
    var links = document.getElementsByTagName("a");
    for(var i=0;i<links.length;i++)
    {
        if(links[i].href)
        {
            links[i].style.color = hex;  
        }
    }  
}



const MyReactPlayer = () => {
  return (
    <div style={{ position: 'relative', width: '75%', height: '500px' }}>
      <ReactPlayer
        url="https://cdn.mannheim-urology.com/videos/Optilume_video_Tosev.mp4"
        width="100%"
        height="100%"
        light='https://cdn.mannheim-urology.com/videos/Optilume_video_Tosev.png'
        controls={true} startTime={7.0} playing={true}
        style={{ position: 'absolute', top: 0, left: 100 }} 
      />
    </div>
  );
};


class Ambassador extends Component {
    render() {
        return (
            <div>
                <section id="about1">
                    <div className="row">
                        <p className="white">
  <p>Dear Patients,</p>
    <p>We are thrilled to announce that Mannheim Urology has become the first Ambassador Centrum for Optilume® in Germany and Europe since 26.11.21. Optilume® is a novel, minimally invasive procedure for the treatment of urethral stricture disease with a drug-coated balloon catheter.</p>
    <p>The technology has been developed and manufactured in the USA by Urotronic Inc, and has been approved for use in the EU since September 2020. In October 2020, Urotronic Inc. signed a definitive agreement, entering into strategic partnership with LABORIE Medical Technologies, enabling LABORIE to market Optilume® in select countries within the EU as a licensed distributor.</p>
    <p>The first Optilume® procedure was performed by Dr. Georgi Tosev in Mannheim, Germany in January 2021. Since then, Dr. Tosev has completed over 40 additional Optilume® procedures and is impressed with the early clinical results seen in his practice. So far we have treated successfully with the Optilume-Balloondilatation bulbar strictures, also as off label use penil strictures, meatal strictures, double strictures and bladder neck stricture. Learn more about our Optilume® services <a href='/Optilume' target="_blank" style={{ color: '#11ABB0' }}> here</a>. </p>
                        <MyReactPlayer/><br/>
    <p>Optilume® combines the advantages of minimally invasive surgery with clinically proven technology to reduce recurrence of scar tissue formation. It has shown promising post-operative results as reported by the ROBUST series of clinical evidence. The treatment is ambulatory, stress-free, simple, and patient recovery can be achieved within hours. The technology has the potential to significantly reduce the cost of treating urethral stricture disease due to its safe and minimally invasive application.</p>
    <p>We are excited about the potential of Optilume® to change perceptions and provide positive outcomes for the treatment of urethral stricture disease. If you are interested in learning more about Optilume® or would like to schedule a consultation, please do not hesitate to contact us.</p>
                        </p>

                    </div>
                </section>
            </div>
        );
    }
}

export default Ambassador;

/*
                        <CardMedia
                            component='img'
                            image={ambassadorPicture}
                            style={
                                {
                                    width: '40%',
                                    objectFit: 'inherit',
                                    objectPosition: 'bottom',
                                    marginLeft: '38%',
                                }}
                        />
*/



// WEBPACK FOOTER //
// ./src/Components/Ambassador.js